// extracted by mini-css-extract-plugin
module.exports = {"flex":"search_flex__12nbS","search":"search_search__1iTEH","button":"search_button__IUX7m"};